import * as http from './http';

// 登录
export const Login = (params) => http.post('/user/boosCloudLogin', params,{interceptRes: true})
// 根据企业名称查询天眼查数据
export const companySearch = (params) => http.post('/company/register/search', params, {loading: false})
// 企业注册
export const companyDo = (params) => http.post('/company/register/do', params)
// 首页政策企业资助列表
export const hisSubsidy = (params) => http.post('/policy/hisSubsidy', params)

// 新增政策数
export const newCount = (params) => http.post('/policy/newCount', params, {interceptRes: false})

// 政策首页
export const policyHome = (params) => http.post('/policy/home', params)

// 企业政策匹配列表
export const companyMatch = (params) => http.post('/policy/companyMatch', params, {loading: false})

// 政策详情
export const Detail = (params) => http.post('/policy/detail', params, {interceptRes: false}, {loading: false})

// 政策搜索列表
export const Search = (params) => http.post('/policy/search', params, {loading: false})

// 分享和交办
export const cardShareInfo = (params) => http.post('/share/cardShareInfo', params, {loading: false})

// 收藏
export const Collection = (params) => http.post('/user/record/add', params, {loading: false})

// 取消收藏
export const cancelCollection = (params) => http.post('/user/record/deleteRecord', params, {loading: false})

// 专家咨询
export const expertTelephone = (params) => http.post('/policyConsult/consult', params, {loading: false})

// 根据父ID 获取子地区集合
export const Area = (params) => http.post('/dict/fullChildren', params, {loading: false})

// 获取产业领域列表
export const industryTypeList = (params) => http.post('/dict/industryList', params, {loading: false})

// 获取政策类型列表
export const policyTypeList = (params) => http.post('/dict/policyTypeList', params, {loading: false})

// 公众号分享
export const getWechatShare = (params) => http.post('/wechat/paShare', params, {loading: false})

// 秀订单
export const showOrder = (params) => http.post('/order/showOrder', params, {loading: false})

// 分享链接浏览次数
export const shareAddVisitNum = (params) => http.post('/share/addVisitNum', params, {loading: false,interceptRes: false})

// 登录日志。session级别的
export const loginLog = (params) => http.post('/user/login/session/log', params, {loading: false,interceptRes: false})

export const updateIncrement = (params) => http.post('/company/info/update-increment', params, {loading: false})
// 政策搜索热词
export const policyHotKey = (params) => http.post('/policy/hotKey', params, {loading: false})
// 查询活动VIP参加次数
export const activityVipTimes = (params) => http.post('/activity/vip/times', params, {loading: false})

export const activityVipGet = (params) => http.post('/activity/vip/get', params, {loading: false})
// 政策详情反馈
export const reqPolicyFeedback = (params) => http.post('/policy/feedback', params, {loading: false})
// 获取申报意向列表
export const reqGetDeclareEntrustList = (params) => http.post('/dict/declareEntrust', params, {loading: true})
// 委托申报
export const reqApplyConsult = (params) => http.post('/policyConsult/entrust', params, {loading: false})
// 获取用户所属地区
export const reqGetAreaOnBS = (params) => http.post('/user/areaInfo', params, {loading: false})
